import $ from 'jquery';

var triggers = $('input[id*="toggle-mobile"]');

$('.js-toolbox').append('<span class="js-lightbox" data-target="mobile-nav" />');

var lightbox = $('.js-lightbox[data-target="mobile-nav"]');

triggers.on('change', function (e) {
  e.stopPropagation();
  $(this).next('input').prop('checked', false);
  $(this).prev('input').prop('checked', false);
});

lightbox.on('click', resetAll);

var resetAll = function () {
  triggers.prop('checked', false);
};

export default { resetAll };
